import React, { useCallback } from 'react'
import { TileSpecification } from 'src/queries/agent/network/agent.models'
import { useDynamicTileQuery } from 'src/queries/insights/insights.queries'

import InsightsTileRenderer from './InsightsTileRenderer/InsightsTileRenderer'
import { PinnedInsightStored } from './pinnedInsights.storage'

interface PinnedInsightTileProps {
  pinnedInsight: PinnedInsightStored
  onTogglePin: (spec: TileSpecification, shouldPin: boolean) => void
}

const PinnedInsightTile: React.FC<PinnedInsightTileProps> = ({
  pinnedInsight,
  onTogglePin,
}) => {
  const { spec } = pinnedInsight

  const { data, isLoading, error } = useDynamicTileQuery(spec)

  const handleTogglePin = useCallback(
    (shouldPin: boolean) => {
      onTogglePin(spec, shouldPin)
    },
    [onTogglePin, spec],
  )

  return (
    <InsightsTileRenderer
      tileSpec={spec}
      tileData={data}
      isLoading={isLoading}
      error={error}
      isPinned
      onTogglePin={handleTogglePin}
    />
  )
}

export default PinnedInsightTile
